angular.module('tf.services')

    .factory('ProjectService', ['$rootScope','$q', 'HttpService', 'UrlEncodingService', 'Project', 'MixpanelService', 'BreadCrumbsService','ProjectStorageService','$uibModal','DemoFarmerService',
        function($rootScope, $q, HttpService, UrlEncodingService, Project, MixpanelService, BreadCrumbsService, ProjectStorageService, $uibModal, DemoFarmerService){
        var service={};

        service.loadProject = function(path){
            var defer = $q.defer();
            UrlEncodingService.decrypt(path).then(function(decoded){
                var query = _.extend({}, {path: decoded.path}, decoded.cid? {cid : decoded.cid} : {});
                HttpService.get("farmer/" + decoded.fid + "/project", query).then(function (res) {
                    var project = new Project(res.data);
                    project.fid = decoded.fid;
                    defer.resolve(project);
                }, function(){
                    defer.reject();
                });
            }, function(){
                defer.reject();
            });
            return defer.promise;
        };

        service.getDemoProject = function(){
            var defer = $q.defer();
            var project = new Project(DemoFarmerService.project);
            service.project = project;
            BreadCrumbsService.set(project.breadcrumbs);
            setCurrentLocation(project);
            defer.resolve(project);
            return defer.promise;
        };

        service.getProject = function(path){
            $rootScope.$broadcast('working', true);
            var defer = $q.defer();
            UrlEncodingService.decrypt(path).then(function(decoded){
                var query = _.extend({}, {path: decoded.path}, decoded.cid? {cid : decoded.cid} : {});
                HttpService.get("farmer/" + decoded.fid + "/project", query).then(function (res) {
                    $rootScope.$broadcast('working', false);
                    var project = new Project(res.data);
                    project.fid = decoded.fid;
                    service.project = project;

                    ProjectStorageService.load().then(function(storedProject){
                        if(storedProject) {
                            var localProject = new Project(storedProject);
                            if (service.project.id === localProject.id) {
                                service.project.name = localProject.name;
                                loadTemplates(localProject);
                            }
                        }
                        defer.resolve(project);

                    });

                    var properties = {
                        "fid"           : project.fid,
                        "project name"  : project.name,
                        "project id"    : project.id
                    };
                    MixpanelService.sendEvent("project-loaded", properties);
                    BreadCrumbsService.set(project.breadcrumbs);
                    setCurrentLocation(project);

                }, function(err){
                        $rootScope.$broadcast('working', false);
                        defer.reject();
                        window.location = "/";
                });
            }, function(){
                $rootScope.$broadcast('working', false);
                defer.reject();
                window.location = "/";
            });
            return defer.promise;
        };

        service.reset = function(path, template){
            var defer = $q.defer();
            $rootScope.$broadcast('working', true);
            service.loadProject(path).then(function(project){
                if(template){
                    var originalTemplate = _.find(project.templates, {originalName : template.originalName});
                    if(originalTemplate){
                        template.controls = originalTemplate.controls;
                    }

                } else {
                    service.project = project;
                }
                $rootScope.$broadcast('working', false);
                defer.resolve(project);
            }, function(){
                $rootScope.$broadcast('working', false);
                defer.reject();
            });
            return defer.promise;
        };

        service.openSettings = function(path){

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'js/components/projectSettings/project-settings.html',
                controller: 'ProjectSettingsController',
                size: 'lg',
                windowTopClass : 'project-settings-modal',
                keyboard : false,
                backdrop : 'static',
                resolve: {
                    project: function () {
                        return service.loadProject(path);
                    }
                }
            });
        };


        function loadTemplates(project){
            for (const localTemplate of project.templates) {
                const serverTemplate = service.project.templates.find(template => template.originalName === localTemplate.originalName && !template.isDuplicated);
                if (serverTemplate) {
                    if (localTemplate.isDuplicated) {
                        const localDupControls = localTemplate.controls;
                        localTemplate.controls = angular.copy(serverTemplate.controls);
                        copyTemplateControls(localDupControls, localTemplate);

                        let pushIndex = service.project.templates.findLastIndex(template => template.originalName === localTemplate.originalName);
                        service.project.templates.splice(pushIndex+1,0,localTemplate);

                    } else {
                        if(localTemplate.use) {
                            serverTemplate.use = localTemplate.use;
                        }
                        serverTemplate.name = localTemplate.name;

                        if(localTemplate.thumbnailSequence){
                            serverTemplate.thumbnailSequence = localTemplate.thumbnailSequence;
                        }
                        if(localTemplate.isSelected){
                            serverTemplate.isSelected = localTemplate.isSelected;
                        }
                        copyTemplateControls(localTemplate.controls, serverTemplate);
                    }
                }
            }
        }

        function copyTemplateControls(controls, template) {
            for(let j = 0 ; j < template.controls.length ; j++){
                const toControl = template.controls[j];
                copyControl(toControl, controls, service.project.getComparableFields());
            }
        }

        function copyControl(toControl, controls, fieldsToCopy){
            var query = {comp : toControl.comp, layer : toControl.layer};
            if(toControl.effect){
                _.extend(query, {effect : toControl.effect});
            }
            var localControl = _.find(controls, query);
            if(localControl && localControl.layerType === toControl.layerType){
                _.each(fieldsToCopy, function(field){
                    toControl[field] = localControl[field];
                });
            }
        }

        function setCurrentLocation(project){
            var item = {};
            item.id = project.id;
            item.name = project.name;
            item.breadcrumbs = project.breadcrumbs;
            item.thumbnail = project.thumbnail;
            item.type = 1;
            $rootScope.currentLocation = item;
        }

        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            if(_.includes(['app.folder', 'app.farmers'], toState.name) && fromState.name === 'app.project'){
                ProjectStorageService.delete();
            } else if (fromState.name === 'app.project'){
                ProjectStorageService.store(service.project);
            }
        });


        service.storeProject = function(){
            return ProjectStorageService.store(service.project);
        };

        service.safeNameRegex = "[`%^&*|+=?;:'\\\",.<>\\\\\\/]";

        return service;
    }])

    .factory('ThumbnailSequence',[function(){
        var thumbnailSequence = function ThumbnailSequence(thumbnails) {
            thumbnails = thumbnails || [];
            if(_.isArray(thumbnails)) {
                this.thumbnails = thumbnails;
            } else {
                this.thumbnails = [thumbnails];
            }
            this.index = 0;
        };

        thumbnailSequence.prototype = {
            get     : function(index){
                if(!index){
                    return this.thumbnails;
                }
                return this.thumbnails[Math.min(index, this.thumbnails.length - 1)];
            },
            set     : function (index) {
                this.index = index;
            },
            current : function(){
                return this.thumbnails[this.index];
            },
            currentIndex : function () {
                return this.index;
            },
            next    : function(){
                this.index = (this.index + 1) % this.thumbnails.length;
                return this.thumbnails[this.index];
            },
            previous: function(){
                this.index = (this.index - 1 + this.thumbnails.length) % this.thumbnails.length;
                return this.thumbnails[this.index];
            },
            length : function(){
                return this.thumbnails.length;
            },
            isEmpty : function () {
                return this.thumbnails.length === 0;
            },
            update : function(thumbnails){
                if(_.isArray(thumbnails)) {
                    this.thumbnails = thumbnails;
                } else {
                    this.thumbnails = [thumbnails];
                }
                if(this.index > this.thumbnails.length - 1){
                    this.index = 0;
                }
            }
        };


        return thumbnailSequence;
    }])
;
